
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.907 121.128a9.94 9.94 0 010-14.066l85.24-85.16c3.888-3.884 10.192-3.884 14.08 0l45.512 45.47a9.939 9.939 0 010 14.066l-85.24 85.158c-3.888 3.885-10.192 3.885-14.08 0l-45.512-45.468z","data-ticket-back":"true"}}),_c('path',{attrs:{"d":"M36.173 85.815l59.592 59.536"}}),_c('path',{attrs:{"d":"M35.334 111.524c-1.423-5.306 1.73-10.76 7.04-12.182l116.44-31.17c5.311-1.422 10.77 1.727 12.194 7.033l16.659 62.111c1.422 5.306-1.73 10.76-7.04 12.182l-116.44 31.17c-5.312 1.422-10.771-1.727-12.194-7.033l-16.659-62.111z","data-ticket-forward":"true"}}),_c('path',{attrs:{"d":"M71.425 91.564l21.812 81.327"}}),_c('path',{attrs:{"d":"M172.362 137.183l-14.924 3.995m4.018-44.659l-14.924 3.996m-1.983 44.113l-14.925 3.996m4.019-44.659l-14.924 3.995m-12.889 3.45l-14.924 3.995m66.914-32.44L87.27 101.85m8.992-36.377L85.337 76.39m21.353-41.18L55.044 86.807m61.578-41.674l-10.925 10.915","data-ticket-text":"true"}})])
          )
        }
      }
    